import { action } from 'satcheljs';
import type { PopoutType } from 'owa-popout-v2';
import type { CalendarComponent } from 'owa-calendar-usage-instrumentation';
import { CustomData } from 'owa-analytics-actions';

export const startShowCalendarFormPerfDatapoint = action(
    'startShowCalendarFormPerfDatapoint',
    (
        datapointName: string,
        formId: string,
        component: CalendarComponent,
        popoutType: PopoutType,
        bundleAlreadyLoaded: boolean,
        otherData?: CustomData
    ) => ({ datapointName, formId, component, popoutType, bundleAlreadyLoaded, otherData })
);
